/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyInfo,
    JsonCompanyInfoFromJSON,
    JsonCompanyInfoFromJSONTyped,
    JsonCompanyInfoToJSON,
} from './JsonCompanyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyInfo
 */
export interface ApiResultOfJsonCompanyInfo {
    /**
     * 
     * @type {JsonCompanyInfo}
     * @memberof ApiResultOfJsonCompanyInfo
     */
    data?: JsonCompanyInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyInfo
     */
    result?: ApiResultOfJsonCompanyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyInfoFromJSON(json: any): ApiResultOfJsonCompanyInfo {
    return ApiResultOfJsonCompanyInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyInfoToJSON(value?: ApiResultOfJsonCompanyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

